import { APP_BASE_HREF } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string,
    private http: HttpClient
  ) {}

  getBaseUrl(): string {
    return this.baseHref + 'api/';
  }

  getBaseHrefUrl(): string {
    return this.baseHref;
  }
  

  createGetServiceCall<T>(serviceUrl: string, params: any): Observable<T> {
    if (typeof params === 'string') {
      return this.http.get<T>(
        serviceUrl +
          (serviceUrl.includes('?') ? '&' : '?') +
          'tstmp=' +
          new Date().getTime() +
          (params == null ? '' : '&' + params),
        {}
      );
    } else {
      return this.http.get<T>(
        serviceUrl +
          (serviceUrl.includes('?') ? '&' : '?') +
          'tstmp=' +
          new Date().getTime(),
        { params: params }
      );
    }
  }

  /**
   * Creates a service post call using raw json (no params - form or query)
   *
   * @param serviceUrl The URL to call
   * @param json The json payload
   */
  createPostServiceCallRawJson<T>(
    serviceUrl: string,
    json: string,
    includeAuthorToken = false
  ): Observable<T> {
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/json'
    );

    return this.http.post<T>(
      serviceUrl +
        (serviceUrl.includes('?') ? '&' : '?') +
        'tstmp=' +
        new Date().getTime(),
      json,
      {
        headers: headers,
      }
    );
  }

  /**
   * Creates a service put call using raw json (no params - form or query)
   *
   * @param serviceUrl The URL to call
   * @param json The json payload
   * @param includeAuthorToken Flag to indicate if the author token should be appened to the authen token using a comma
   */
  createPutServiceCallRawJson<T>(
    serviceUrl: string,
    json: string,
    includeAuthorToken = false
  ): Observable<T> {
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/json'
    );

    return this.http.put<T>(
      serviceUrl +
        (serviceUrl.includes('?') ? '&' : '?') +
        'tstmp=' +
        new Date().getTime(),
      json,
      {
        headers: headers,
      }
    );
  }

  /**
   * Creates a service delete call
   *
   * @param serviceUrl The URL to call
   * @param includeAuthorToken Flag to indicate if the author token should be appened to the authen token using a comma
   */
  createDeleteServiceCall<T>(
    serviceUrl: string,
    includeAuthorToken = false
  ): Observable<T> {
    const headers = new HttpHeaders().append(
      'Content-Type',
      'application/json'
    );
    return this.http.delete<T>(
      serviceUrl +
        (serviceUrl.includes('?') ? '&' : '?') +
        'tstmp=' +
        new Date().getTime(),
      { headers: headers }
    );
  }
}
